var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.params.data.custom_tag_id)?_c('div',{staticClass:"d-flex text-center"},[_c('vx-tooltip',{attrs:{"text":`${this.params.data.customtag.comments}`,"position":"bottom"}},[_vm._v("\n\t\t\t"+_vm._s(this.params.data.customtag.tag_name)+"\n\t\t")])],1):_c('div',{staticClass:"d-flex text-center"},[_c('p',[_vm._v("null")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }